import axios from 'axios';

// Create a centralized axios instance with credentials enabled
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors (unauthorized)
    if (error.response?.status === 401) {
      // Optionally redirect to login or handle auth errors
      console.warn('Unauthorized request - authentication required');
    }
    return Promise.reject(error);
  }
);

export default api;
